/**
 * Legacy client detail — /admin/clients/$id (redirect stub).
 *
 * The old per-client detail screen is retired: client detail now lives in the
 * client tenant's own /app surface, reached via a Client Book act-as session.
 * This route redirects (dropping the id) so existing bookmarks / links don't
 * hit a dead stub.
 */

import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/admin/clients/$id')({
  beforeLoad: () => {
    throw redirect({ to: '/admin/client-book' });
  },
});
